import { colors } from "@components/Theme/colors";
import { Box, Button, Container, Stack, Typography } from "@mui/material";
import NextLink from "next/link";
import { APITypes } from "utils/api.types";
interface VacatureDetailAboutBlockProps {
  block: APITypes.Components.ContentBlocks.VacatureDetail;
  position: APITypes.Components.Job;
}
const VacatureDetailAboutBlock = ({
  block,
  position
}: VacatureDetailAboutBlockProps) => {
  return <Box py={10} sx={{
    backgroundColor: colors.white.main
  }} data-sentry-element="Box" data-sentry-component="VacatureDetailAboutBlock" data-sentry-source-file="VacatureDetailAboutBlock.tsx">
      <Container data-sentry-element="Container" data-sentry-source-file="VacatureDetailAboutBlock.tsx">
        <Stack flexDirection={{
        xs: "column",
        md: "row"
      }} gap={{
        xs: 2,
        md: 4
      }} data-sentry-element="Stack" data-sentry-source-file="VacatureDetailAboutBlock.tsx">
          <Stack flex={1} data-sentry-element="Stack" data-sentry-source-file="VacatureDetailAboutBlock.tsx">
            <Typography color={colors.secondary.main} sx={{
            fontWeight: 600,
            textAlign: {
              xs: "left",
              md: "right"
            }
          }} data-sentry-element="Typography" data-sentry-source-file="VacatureDetailAboutBlock.tsx">
              {block.offerSubTitle}
            </Typography>
            <Typography variant="h2" sx={{
            textAlign: {
              xs: "left",
              md: "right"
            }
          }} data-sentry-element="Typography" data-sentry-source-file="VacatureDetailAboutBlock.tsx">
              {block.offerTitle}
            </Typography>
          </Stack>
          <Stack flex={4} gap={2} sx={{
          mt: {
            xs: 0,
            md: 12
          }
        }} data-sentry-element="Stack" data-sentry-source-file="VacatureDetailAboutBlock.tsx">
            <Typography component={"div"} data-sentry-element="Typography" data-sentry-source-file="VacatureDetailAboutBlock.tsx">
              <Box sx={{
              fontSize: "16px",
              padding: {
                xs: "0 1rem",
                md: "0"
              },
              ["ul"]: {
                paddingLeft: {
                  xs: "0",
                  md: "10px"
                }
              },
              "& li::marker": {
                content: "'━'",
                color: colors.secondary.main
              },
              "& li": {
                pl: "10px",
                pb: "20px"
              }
            }} dangerouslySetInnerHTML={{
              __html: position.compensationBenefits
            }} data-sentry-element="Box" data-sentry-source-file="VacatureDetailAboutBlock.tsx" />
            </Typography>
            <Stack flexDirection={"row"} data-sentry-element="Stack" data-sentry-source-file="VacatureDetailAboutBlock.tsx">
              <Button component={NextLink} variant="contained" href={block.offerButton.href} data-sentry-element="Button" data-sentry-source-file="VacatureDetailAboutBlock.tsx">
                {block.offerButton.title}
              </Button>
            </Stack>
          </Stack>
        </Stack>
      </Container>
    </Box>;
};
export default VacatureDetailAboutBlock;